const transparencyTools = [
  {
    target: "#primary-search-box",
    content:
      "Mind if we quickly walk through our transparency features? Let’s start with a new search.",
  },
  {
    target: ".tour-newsguard-icon",
    content:
      "This blue shield is the NewsGuard Reliability Rating. The score represents the overall trustworthiness of this publisher.",
    data: {
      setup: ({ index, action }) => {
        window.dispatchEvent(
          new CustomEvent("tour:app:search", {
            detail: {
              index,
              action,
              term: "What is Blockchain",
            },
          })
        );
      },
    },
  },
  {
    target: "#tour-newsguard-source-info",
    content:
      "When you click the NewsGuard rating, it opens this side panel where you can examine NewsGuard’s nine ratings criteria. Think of these as “journalism best practices” and can serve as a roadmap for assessing any content you encounter, anywhere.",
    disableScrolling: true,
    data: {
      setup: ({ index, action, step, continueTour }) => {
        const target = document.querySelector(step.target);
        if (target != null) {
          window.dispatchEvent(
            new CustomEvent(
              `tour:app:article:sourceOpen:${target.dataset.articleId}`,
              {
                detail: {
                  index,
                  action,
                },
              }
            )
          );
        } else {
          continueTour();
        }
      },
    },
  },
  {
    target: "#tour-newsguard-source-button",
    content:
      "Click here to supercharge your media literacy by reviewing NewsGuard’s extensive research on this source.",
  },
  {
    target: ".tour-all-sides-icon",
    content:
      "This icon represents the AllSides Media Bias Rating. Everyone has some bias so it’s important to know how this plays a part when engaging content.",
    data: {
      setup: ({ continueTour, nextStep, action, index }) => {
        window.dispatchEvent(new CustomEvent("tour:app:sourceInfo:close"));
        const target = document.querySelector(nextStep.target);
        console.log(target, target?.dataset);
        if (target != null) {
          window.dispatchEvent(
            new CustomEvent(
              `tour:app:article:slideTo:${target.dataset.articleId}`,
              {
                detail: {
                  index,
                  action,
                },
              }
            )
          );
        } else {
          continueTour();
        }
      },
    },
  },
  {
    target: "#tour-all-sides-source-info",
    content:
      "AllSides has developed a simple, five-point scale that indicates the likely bias of this publisher. Not sure what this rating actually means? Click the rating in the top right corner to learn more about it.",
    data: {
      setup: ({ index, action, step, continueTour }) => {
        const target = document.querySelector(step.target);
        if (target != null) {
          window.dispatchEvent(
            new CustomEvent(
              `tour:app:article:sourceOpen:${target.dataset.articleId}`,
              {
                detail: {
                  index,
                  action,
                },
              }
            )
          );
        } else {
          continueTour();
        }
      },
    },
  },
  {
    target: "#tour-all-sides-source-button",
    content: "Click here to read about the rating for this specific publisher.",
  },
  {
    target: ".tour-charity-icon",
    content:
      "These stars represent the Charity Navigator rating for this source.",
    data: {
      setup: ({ continueTour, nextStep, action, index }) => {
        window.dispatchEvent(new CustomEvent("tour:app:sourceInfo:close"));
        const target = document.querySelector(nextStep.target);
        console.log(target, target?.dataset);
        if (target != null) {
          window.dispatchEvent(
            new CustomEvent(
              `tour:app:article:slideTo:${target.dataset.articleId}`,
              {
                detail: {
                  index,
                  action,
                },
              }
            )
          );
        } else {
          continueTour();
        }
      },
    },
  },
  {
    target: "#tour-charity-source-info",
    content:
      "The Charity Navigator rating only applies to select U.S. non-profits. It provides insight into the accountability and transparency of the parent organization. It has no bearing on the quality or bias of the content.",
    data: {
      setup: ({ index, action, step, continueTour }) => {
        const target = document.querySelector(step.target);
        if (target != null) {
          window.dispatchEvent(
            new CustomEvent(
              `tour:app:article:sourceOpen:${target.dataset.articleId}`,
              {
                detail: {
                  index,
                  action,
                },
              }
            )
          );
        } else {
          continueTour();
        }
      },
    },
  },
  {
    target: "#tour-charity-source-button",
    content:
      "Click here to learn more about the Charity Navigator rating for this specific source.",
  },
  {
    target: "#sooth-logo",
    content:
      "Clicking the Sooth icon will always bring you back to the Initial Search Page. That’s it for now!",
    data: {
      setup: ({ continueTour }) => {
        window.dispatchEvent(new CustomEvent("tour:app:sourceInfo:close"));
        continueTour();
      },
    },
  },
];

export default transparencyTools;
